import {
  UseFormReset,
  UseFormResetField,
  UseFormSetValue,
} from "react-hook-form";
import {Process} from "views/ProcessDetails/refactor/types/process.types";
import {
  Voyage,
  VoyageToSend,
} from "views/ProcessDetails/refactor/types/voyages.types";
import {
  shouldUpdateNextVoyageOrigin,
  getVoyageContextBeforeDeletion,
  updateNextVoyageOrigin,
} from "views/ProcessDetails/refactor/components/ProcessBoarding/components/VoyagesV2/helpers/voyageDeletionHelpers";

type VoyageDeletionFlowDependencies = {
  addNewVoyage: (
    id: number,
    voyages: Partial<VoyageToSend>,
  ) => Promise<Process | undefined>;
  refetchProcess: () => Promise<Process | undefined>;
  reset: UseFormReset<Process>;
  resetField: UseFormResetField<Process>;
  setValue: UseFormSetValue<Process>;
  processId: number;
  allVoyages: Voyage[];
};

export const useVoyageDeletionFlow = (
  dependencies: VoyageDeletionFlowDependencies,
) => {
  const refetchProcessAndResetForm = async () => {
    try {
      const response = await dependencies.refetchProcess();
      dependencies.reset(response);
      dependencies.resetField("boarding.voyages");
    } catch (error) {
      console.error(error);
    }
  };

  const executeDeletionFlow = async (
    deletedVoyage: Voyage,
    deletedIndex: number,
  ) => {
    const context = getVoyageContextBeforeDeletion(
      dependencies.allVoyages,
      deletedIndex,
    );

    if (!shouldUpdateNextVoyageOrigin(deletedVoyage, dependencies.allVoyages)) {
      await refetchProcessAndResetForm();
      return;
    }

    await updateNextVoyageOrigin(
      context,
      dependencies.processId,
      dependencies.addNewVoyage,
      dependencies.setValue,
      dependencies.resetField,
      dependencies.reset,
    );
  };

  return {
    executeDeletionFlow,
    refetchProcessAndResetForm,
  };
};
